import { Application } from '@pixi/app';
import { Assets } from "@pixi/assets";

export class Game extends Application {
    public constructor(
    ) {
        super({
            backgroundColor: 0xffffff,
            backgroundAlpha: 1.0,
            width: window.innerWidth,
            height: window.innerHeight,
            antialias: true,
            autoDensity: true,
            resolution: window.devicePixelRatio
        });
        // @ts-ignore
        const gl: WebGLRenderingContext | WebGL2RenderingContext = this.renderer.gl;
        window.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    }

    public async launch(manifestPath: string): Promise<void> {
        const manifest = await (await fetch(manifestPath)).json();
        await Assets.init({ manifest });
    }
}